<template>
  <EntryCard :entry="entry">
  <template slot="text">
    <span class="text--disabled overline mr-2">Log</span>
    <span class="body-1">
      {{ entry.text }}
      <!-- <template v-html="entry.text"></template> -->
    </span>
  </template>
  </EntryCard>
</template>

<script>
  import EntryCard from '@/components/entry/EntryCard'
  export default {
    components: { EntryCard },
    props: {
      entry: {
        type: Object,
      },
    },
  };
</script>
